let nextOpenId = 0;

export const getNextOpenId = (): number => {
  nextOpenId += 1;
  return nextOpenId;
};
